webpackJsonp([74],{

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1377);


/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(212);

var _datetime2 = _interopRequireDefault(_datetime);

var _fr = __webpack_require__(853);

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('fr', _fr2.default);

/***/ })

},[1376]);


// WEBPACK FOOTER //
// app/datetime.fr-3c348c58b77753c644b4.js